export const ADD_DATA_CATEGORY = 'ADD_DATA_CATEGORY';
export const ADD_DATA_CATEGORY_FAILED = 'ADD_DATA_CATEGORY_FAILED';
export const ADD_DATA_CATEGORY_SUCCESS = 'ADD_DATA_CATEGORY_SUCCESS';

export const ADD_DATASET = 'ADD_DATASET';
export const ADD_DATASET_FAILED = 'ADD_DATASET_FAILED';
export const ADD_DATASET_SUCCESS = 'ADD_DATASET_SUCCESS';

export const DELETING_DATA_CATEGORY = 'DELETE_DATA_CATEGORY';
export const DELETE_DATA_CATEGORY_COMPLETE = 'DELETE_DATA_CATEGORY_COMPLETE';

export const UPDATING_DATA_CATEGORY = 'UPDATING_DATA_CATEGORY';
export const UPDATING_DATA_CATEGORY_COMPLETE = 'UPDATING_DATA_CATEGORY_COMPLETE';

export const DELETE_SUB_DATA_CATEGORY = 'DELETE_SUB_DATA_CATEGORY';
export const DELETE_SUB_DATA_CATEGORY_COMPLETE = 'DELETE_SUB_DATA_CATEGORY_COMPLETE';

export const ADD_DATA_SUB_CATEGORY = 'ADD_DATA_SUB_CATEGORY';
export const ADD_DATA_SUB_CATEGORY_COMPLETE = 'ADD_DATA_SUB_CATEGORY_COMPLETE';

export const UPDATE_DATA_SUB_CATEGORY = 'UPDATE_DATA_SUB_CATEGORY';
export const UPDATE_DATA_SUB_CATEGORY_COMPLETE = 'UPDATE_DATA_SUB_CATEGORY_COMPLETE';

export const DELETE_DATASET = 'DELETE_DATASET';
export const DELETE_DATASET_COMPLETE = 'DELETE_DATASET_COMPLETE';

export const FETCH_EXCEL_CATEGORIES = 'FETCH_EXCEL_CATEGORIES';
export const FETCH_EXCEL_CATEGORIES_COMPLETE = 'FETCH_EXCEL_CATEGORIES_COMPLETE';

export const FETCH_EXCEL_INDICATIONS = 'FETCH_EXCEL_INDICATIONS';
export const FETCH_EXCEL_INDICATIONS_COMPLETE = 'FETCH_EXCEL_INDICATIONS_COMPLETE';

export const FETCH_EXCEL_CHART_DATA = 'FETCH_EXCEL_CHART_DATA';
export const FETCH_EXCEL_CHART_DATA_COMPLETE = 'FETCH_EXCEL_CHART_DATA_COMPLETE';

export const FETCH_EXCEL_YEARS = 'FETCH_EXCEL_YEARS';
export const FETCH_EXCEL_YEARS_COMPLETE = 'FETCH_EXCEL_YEARS_COMPLETE';

export const FETCH_DATA_CATEGORIES = 'FETCH_DATA_CATEGORIES';
export const FETCH_DATA_CATEGORIES_COMPLETE = 'FETCH_DATA_CATEGORIES_COMPLETE';

export const FETCH_SUB_DATA_CATEGORIES = 'FETCH_SUB_DATA_CATEGORIES';
export const FETCH_SUB_DATA_CATEGORIES_COMPLETE = 'FETCH_SUB_DATA_CATEGORIES_COMPLETE';

export const FETCH_DATA_CATEGORY = 'FETCH_DATA_CATEGORY';
export const FETCH_DATA_CATEGORY_COMPLETE = 'FETCH_DATA_CATEGORY_COMPLETE';

export const FETCH_DATASETS = 'FETCH_DATASETS';
export const FETCH_DATASETS_COMPLETE = 'FETCH_DATASETS_COMPLETE';

export const FETCH_DATA_VALUES = 'FETCH_DATA_VALUES';
export const FETCH_DATA_VALUES_COMPLETE = 'FETCH_DATA_VALUES_COMPLETE';

export const FETCH_TRENDING_CATEGORIES = 'FETCH_TRENDING_CATEGORIES';
export const FETCH_TRENDING_CATEGORIES_COMPLETE = 'FETCH_TRENDING_CATEGORIES_COMPLETE';


